import React from 'react'

function SingleStanding({ standing, index, type }) {

    function formatStanding(index, description) {
        let className = ""
        if (index + 1 === 1 || description?.includes("Promotion")) {
            if (description?.includes("Qualification") || description?.includes("Play Off")) {
                className = "warning text-white"
            } else {

                className = "success text-white"
            }
        }

        if (description?.includes("Relegation")) {
            className = "danger text-white"
        }
        return className
    }

    return (
        <React.Fragment>
            <div className="table-responsive mb-3" style={{ fontSize: "0.4rem" }}>
                <table className="table table-striped table-hover table-sm">
                    <thead className="bg-dark">
                        <tr>
                            <th></th>
                            <th>{type === "groups" && `Gruppe ${index + 1}`} </th>
                            <th>P</th>
                            <th>W</th>
                            <th>D</th>
                            <th>L</th>
                            <th>GF</th>
                            <th>GA</th>
                            <th>GD</th>
                            <th>Points</th>
                            <th>Form</th>
                        </tr>
                    </thead>
                    <tbody>
                        {standing?.map((team, index) => {
                            return (
                                <tr key={index}>
                                    <td><span className={`bg-${formatStanding(index, team.description)} round square p-1 text-center`}>{index + 1}</span></td>
                                    <td>{team.teamName}</td>
                                    <td>{team.all.matchsPlayed}</td>
                                    <td>{team.all.win}</td>
                                    <td>{team.all.draw}</td>
                                    <td>{team.all.lose}</td>
                                    <td>{team.all.goalsFor}</td>
                                    <td>{team.all.goalsAgainst}</td>
                                    <td>{team.goalsDiff}</td>
                                    <td>{team.points}</td>
                                    <td>{team.forme}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    )
}
export default SingleStanding